<template>
  <transition name="on-message-fade">
    <div v-if="visible" class="on-message" :class="`on-message--${type}`">
      <div class="on-message__icon-wrapper">
        <img :src="iconSrc" class="on-message__icon" alt="icon" />
      </div>
      <span class="on-message__text">{{ message }}</span>
      <div class="on-message__close-wrapper" @click="handleClose">
        <span class="on-message__close">×</span>
      </div>
    </div>
  </transition>
</template>

<script>
/**
 * Message 消息提示组件
 * @author Nemo
 * @description 用于显示成功或错误的消息提示
 */
export default {
  name: 'OnMessage',
  props: {
    // 消息类型：success | error
    type: {
      type: String,
      default: 'success',
      validator: (value) => ['success', 'error'].includes(value),
    },
    // 显示的消息文本
    message: {
      type: String,
      default: '',
    },
    // 自动关闭的延迟时间（毫秒）
    duration: {
      type: Number,
      default: 3000,
    },
  },
  data() {
    return {
      visible: false,
      timer: null,
    };
  },
  computed: {
    iconSrc() {
      return this.type === 'success'
        ? require('@/componentsV2/busi/Modal/success.png')
        : require('@/componentsV2/busi/Modal/error.png');
    },
  },
  mounted() {
    this.visible = true;
    this.startTimer();
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    // 启动自动关闭定时器
    startTimer() {
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          this.handleClose();
        }, this.duration);
      }
    },
    // 清除定时器
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    // 关闭消息
    handleClose() {
      this.visible = false;
      this.clearTimer();
      setTimeout(() => {
        this.$destroy();
        if (this.$el && this.$el.parentNode) {
          this.$el.parentNode.removeChild(this.$el);
        }
      }, 300);
    },
  },
};
</script>

<style lang="scss" scoped>
.on-message {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  width: 295px;
  height: 44px;
  padding: 4px 16px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  z-index: 9999;

  &--success {
    background-color: #d1f4e0;
  }

  &--error {
    background-color: #fce8db;
  }

  &__icon-wrapper {
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-right: 8px;
  }

  &__icon {
    width: 14.13px;
    height: 14.13px;
  }

  &__text {
    flex: 1;
    font-size: 14px;
    font-family: "Open Sans regular";
    color: #333;
    line-height: 1.5;
    text-align: left;
    margin-right: 24px;
  }

  &__close-wrapper {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.7;
    }
  }

  &__close {
    width: 9.49px;
    height: 9.49px;
    color: #999;
    line-height: 9.49px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

// 过渡动画
.on-message-fade-enter-active,
.on-message-fade-leave-active {
  transition: all 0.3s ease;
}

.on-message-fade-enter,
.on-message-fade-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-20px);
}
</style>
